export enum PriceEntryType {
  None = '',
  PriceVerify = 'PriceVerify',
  PriceRequired = 'PriceRequired',
}
